// extracted by mini-css-extract-plugin
export default {"commentCell":"styles_commentCell__UNziN","commentContainer":"styles_commentContainer__p8x2I"};